import { uploadFile as defaultUploadFile } from "../../../services/upload";

export const UPLOAD_LOADING_KEY_BY_FIELD = {
  imgThumb: "imgFileLoading",
  urlVideoS3: "videoFileLoading",
  urlShortVideoS3: "shortVideoFileLoading",
  printVersion_pt: "printVersionLoading",
  printVersion_en: "printVersionLoading",
  printVersion_es: "printVersionLoading",
};

export function resolveUploadErrors(err) {
  return (
    err?.response?.data?.errors || [
      {
        message:
          err?.message || "Falha ao enviar o arquivo. Tente novamente.",
      },
    ]
  );
}

/**
 * Envia arquivo de um campo da lição via serviço único de upload.
 * @param {{ name: string, file: File|undefined|null }} params
 * @param {{ uploadFile?: Function, onProgress?: (pct: number) => void }} [deps]
 */
export async function uploadLessonFile(
  { name, file },
  { uploadFile = defaultUploadFile, onProgress } = {}
) {
  if (!file) {
    return { ok: false, cancelled: true, name };
  }

  try {
    const data = await uploadFile(file, { onProgress });
    return { ok: true, name, url: data.url, data };
  } catch (err) {
    return {
      ok: false,
      name,
      errors: resolveUploadErrors(err),
      err,
    };
  }
}
